/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MessagesAliases {
  AVATAR_0 = 'avatar-0',
  CHECKBOX_IMPORTANT = 'checkbox-important',
  CHECKBOX_NOT_READ = 'checkbox-not-read',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_MESSAGES = 'deck-messages',
  FETCH_MESSAGES = 'fetch-messages',
  FIELD_DATE_RELEASE = 'field-date-release',
  FIELD_FROM = 'field-from',
  FIELD_IMPORTANT = 'field-important',
  FIELD_NOT_READ = 'field-not-read',
  FIELD_UNTIL = 'field-until',
  FILTER_CONSULT_MESSAGES = 'filter-consult-messages',
  FILTERED_LIST = 'filtered-list',
  HPMS_CUSTOM_CARD_MESSAGES = 'hpms-custom-card-messages',
  HPMS_DYNAMIC_CONTENT_FIELD_STATUS = 'hpms-dynamic-content-field-status',
  MAPPER_0 = 'mapper-0',
  PANEL_MESSAGES = 'panel-messages',
}
export { MessagesAliases };
